import { render } from "./CustomDropDown.vue?vue&type=template&id=3b6710e0&scoped=true"
import script from "./CustomDropDown.vue?vue&type=script&lang=js"
export * from "./CustomDropDown.vue?vue&type=script&lang=js"

import "./CustomDropDown.vue?vue&type=style&index=0&id=3b6710e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6710e0"]])

export default __exports__